import { yupResolver } from '@hookform/resolvers/yup';
import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';
import { useForm } from 'react-hook-form';
import {
  FormLimiteCredito,
  formLimiteCreditoBlank,
  FormRegraEmpresa,
  formRegraEmpresaBlank,
  UseFormProps,
} from '~/pages/RegraDeEmpresa/protocols';
import { schema } from './abas/Financeiro/schema';

type RegrasDeEmpresaContextData = {
  // Select: Select[];
  // GrupoEmpresas: GrupoEmpresa[];
  // initLoja: boolean;
  // handleClearForm: () => void;
  // onChangeInit: (value: boolean) => void;
  inicializado: boolean;
  handleInicializado: (value: boolean) => void;
  formRegraEmpresa: FormRegraEmpresa;
  handleFormRegraEmpresa: (form: FormRegraEmpresa) => void;
  formLimiteCredito: FormLimiteCredito;
  handleFormLimiteCredito: (form: FormLimiteCredito) => void;
  isUpdate: boolean;
  handleIsUpdate: (value: boolean) => void;
  handleClearForm: () => void;
  handleClearFormLimite: () => void;
  formTela: UseFormProps;
  isEdit: boolean;
  setIsEdit: (value: boolean) => void;
  editingId: number | string | null;
  setEditingId: (id: number | string | null) => void;
  flgEnviaIbsCbs: boolean;
  handleFlgEnviaIbsCbs: (send: boolean) => void;
  disabledInputsIbsCbs: {
    cbs: boolean;
    ibs_mun: boolean;
    ibs_uf: boolean;
  };
};

export const RegrasDeEmpresaContext = createContext(
  {} as RegrasDeEmpresaContextData,
);
interface RegrasDeEmpresaContextProviderProps {
  children: ReactNode;
}

export function RegraEmpresaContextProvider({
  children,
}: RegrasDeEmpresaContextProviderProps): JSX.Element {
  const [isUpdate, setIsUpdate] = useState(false);
  const [inicializado, setInicializado] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editingId, setEditingId] = useState<number | string | null>(null);
  const [flgEnviaIbsCbs, setFlgEnviaIbsCbs] = useState<boolean>(false);
  const [disabledInputsIbsCbs, setDisabledInputsIbsCbs] = useState<{
    cbs: boolean;
    ibs_mun: boolean;
    ibs_uf: boolean;
  }>({ cbs: false, ibs_mun: false, ibs_uf: false });

  const [formRegraEmpresa, setFormRegraEmpresa] = useState<FormRegraEmpresa>(
    formRegraEmpresaBlank,
  );

  const {
    register,
    getValues,
    handleSubmit,
    formState,
    control,
    setValue,
    watch,
    reset,
    setFocus,
    clearErrors,
    setError,
    resetField,
  } = useForm({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const formTela: UseFormProps = {
    register,
    getValues,
    handleSubmit,
    formState,
    control,
    setValue,
    watch,
    reset,
    setFocus,
    clearErrors,
    setError,
    resetField,
  };

  const handleIsUpdate = useCallback((value: boolean) => {
    setIsUpdate(value);
  }, []);

  const handleFlgEnviaIbsCbs = useCallback(
    (send: boolean) => {
      setFlgEnviaIbsCbs(send);
      if (send === false) {
        setValue('per_ibs_mun_teste', '');
        setValue('per_ibs_uf_teste', '');
        setValue('per_cbs_teste', '');
        return setDisabledInputsIbsCbs({
          cbs: true,
          ibs_mun: true,
          ibs_uf: true,
        });
      }
      setDisabledInputsIbsCbs({
        cbs: false,
        ibs_mun: false,
        ibs_uf: false,
      });
    },
    [setValue],
  );

  const handleInicializado = useCallback((value: boolean) => {
    setInicializado(value);
  }, []);
  const handleFormRegraEmpresa = useCallback((form: FormRegraEmpresa) => {
    setFormRegraEmpresa(form);
  }, []);

  const [formLimiteCredito, setFormLimiteCredito] =
    React.useState<FormLimiteCredito>(formLimiteCreditoBlank);

  const handleFormLimiteCredito = useCallback((form: FormLimiteCredito) => {
    setFormLimiteCredito(form);
  }, []);

  const handleClearForm = useCallback(() => {
    const formRegraEmpresaBlank2: FormRegraEmpresa = {
      cod_grupo_empresa: {
        value: { label: '', value: undefined },
        isInvalid: true,
        isRequired: true,
      },
      tipo_margem: {
        value: { label: '', value: undefined },
        isInvalid: true,
        isRequired: true,
      },
      tipo_custo: {
        value: { label: '', value: undefined },
        isInvalid: false,
        isRequired: false,
      },
      per_tol_custo: {
        value: '',
        isInvalid: false,
        isRequired: false,
      },
      per_bloq_custo: {
        value: '',
        isInvalid: false,
        isRequired: false,
      },
      per_tol_venda: {
        value: '',
        isInvalid: false,
        isRequired: false,
      },
      per_bloq_venda: {
        value: '',
        isInvalid: false,
        isRequired: false,
      },
      cod_status_pdv: {
        value: { label: '', value: undefined },
        isInvalid: true,
        isRequired: true,
      },
      flg_prod_diversos: {
        value: false,
        isInvalid: false,
        isRequired: false,
      },
      flg_mix_cad: {
        value: false,
        isInvalid: false,
        isRequired: false,
      },
      flg_carac_especial: {
        value: false,
        isInvalid: false,
        isRequired: false,
      },
      flg_n_aut_cpf_cli: {
        value: false,
        isInvalid: false,
        isRequired: false,
      },
      flg_n_aut_cnpj_for: {
        value: false,
        isInvalid: false,
        isRequired: false,
      },
      Limites: {
        limites: [],
        isInvalid: false,
        isRequired: false,
      },
      val_tolerancia_tes: {
        value: '',
        isInvalid: false,
        isRequired: false,
      },
      tipo_cobranca_tes: {
        value: { label: '', value: undefined },
        isInvalid: false,
        isRequired: false,
      },
    };

    reset();

    [
      'per_tol_custo',
      'per_bloq_custo',
      'per_tol_venda',
      'per_bloq_venda',
      'val_tolerancia_tes',
      'per_juros_dia',
      'qtd_dias_carencia_juros',
    ].forEach((field) => {
      setTimeout(() => {
        setValue(field, '');
        clearErrors(field);
        const input = document.querySelector(
          `input[name="${field}"]`,
        ) as HTMLInputElement | null;
        if (input) input.value = '';
      }, 150);
    });

    setValue('cod_grupo_empresa', {
      label: 'Selecione um Grupo',
      value: undefined,
    });
    setValue('tipo_margem', { label: 'Selecione a Margem', value: undefined });
    setValue('cod_status_pdv', {
      label: 'Selecione o Status',
      value: undefined,
    });
    handleFlgEnviaIbsCbs(false);
    setValue('per_ibs_mun_teste', '');
    setValue('per_ibs_uf_teste', '');
    setValue('per_cbs_teste', '');

    setFormRegraEmpresa(formRegraEmpresaBlank2);
    setFormLimiteCredito(formLimiteCreditoBlank);
    setIsEdit(false);
  }, [clearErrors, reset, setValue, handleFlgEnviaIbsCbs]);

  const handleClearFormLimite = () => {
    setFormLimiteCredito(formLimiteCreditoBlank);
    setValue('val_limite', '');
    setValue('cod_finalizadora', {
      value: null,
      label: '',
      des_finalizadora: '',
    });
    setIsEdit(false);
    setEditingId(null);
    const inputFin = document.querySelector(
      '[name="cod_finalizadora"]',
    ) as HTMLInputElement | null;

    if (inputFin) inputFin.value = '';
  };

  return (
    <RegrasDeEmpresaContext.Provider
      value={{
        formRegraEmpresa,
        handleFormRegraEmpresa,
        isUpdate,
        handleIsUpdate,
        handleClearForm,
        handleFormLimiteCredito,
        formLimiteCredito,
        handleClearFormLimite,
        inicializado,
        handleInicializado,
        formTela,
        isEdit,
        setIsEdit,
        editingId,
        setEditingId,
        flgEnviaIbsCbs,
        handleFlgEnviaIbsCbs,
        disabledInputsIbsCbs,
      }}
    >
      {children}
    </RegrasDeEmpresaContext.Provider>
  );
}

export const useRegraEmpresa = (): RegrasDeEmpresaContextData => {
  return useContext(RegrasDeEmpresaContext);
};
